// Sends the browser to Google's sign-in page. Google redirects back to the
// backend callback, which hands off to OAuthCallback.vue. The state prefix
// ('register' or 'login') is stored so the redirect back can be recognised.
export function startGoogleOAuth(prefix = 'register') {
  const state = `${prefix}-${Math.random().toString(36).substring(2, 15)}`;
  localStorage.setItem('oauth_state', state);

  window.location.href = 'https://accounts.google.com/o/oauth2/auth?' +
    `client_id=${process.env.VUE_APP_GOOGLE_CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(window.location.origin + '/api/auth/google/callback/')}` +
    '&response_type=code' +
    `&scope=${encodeURIComponent('profile email')}` +
    `&state=${state}` +
    '&prompt=select_account';
}

// Facebook and Instagram's in-app browsers block Google sign-in.
export const isInAppBrowser = () => /FBAN|FBAV|FB_IAB|Instagram/i.test(navigator.userAgent || '');
